export default [
	{
		// kees&kees
		"id": 1,
		"organisation": "fabriek",
		"name": "De Argumentenfabriek",
		"url": "https://www.argumentenfabriek.nl",
		"code": "16a8529f757fd452696c0c48049e45d6",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'mini', 'geneesmiddelenzorg']
	},
	{
		// A6D3KT9S
		"id": 2,
		"organisation": "vvaa",
		"name": "VvAA ",
		"url": "https://www.vvaa.nl",
		"code": "4bcd45e7a51acf8e845067d96afb7693",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// BK3V8S5X
		"id": 3,
		"organisation": "patientenfederatie",
		"name": "Patiëntenfederatie Nederland ",
		"code": "64a0ff286fb7978ae0c7c4c7e31a3c8f",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// CH7S42XP
		"id": 4,
		"organisation": "nfu",
		"name": "Nederlandse Federatie van Universitair Medische Centra ",
		"code": "193387a9f745316bae99eb8eaca744c1",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// DGXC7D6H
		"id": 5,
		"organisation": "vws",
		"name": "Ministerie van Volksgezondheid, Welzijn en Sport ",
		"code": "ec89c05ae3eecf1eeee194ef21c17f27",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// EBD45S3L
		"id": 6,
		"organisation": "rivm",
		"name": "Rijksinstituut voor Volksgezondheid en Milieu",
		"code": "78b3cbc42b66ae70fafbb0c088c35eec",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// FHSJS5QU
		"id": 7,
		"organisation": "zin",
		"name": "Zorginstituut Nederland ",
		"code": "4daaefe1a35c83ffd1e5e179c4e3329f",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// GE52LX6A
		"id": 8,
		"organisation": "nvz",
		"name": "Nederlandse Vereniging van Ziekenhuizen ",
		"code": "d8601034fef511787b400f9815ce7902",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg','geneesmiddelenzorg']
	},
	{
		// HP7S3N5P
		"id": 9,
		"organisation": "zn",
		"name": "Zorgverzekeraars Nederland ",
		"code": "598257ca73aedaaac293a5c213517ab0",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// J4D84S8M
		"id": 10,
		"organisation": "vilans",
		"name": "Vilans ",
		"code": "2690ecea5522b1d7d0cf13aeb7ad8a6b",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// K7DW21AY
		"id": 11,
		"organisation": "ibmg",
		"name": "Instituut Beleid & Management Gezondheidszorg",
		"code": "e03b55bc012c4765da193779b9a7b450",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// L8DG4S34
		"id": 12,
		"organisation": "lad",
		"name": "Landelijke Vereniging van Artsen in Dienstverband ",
		"code": "c2b98183cc4c5d1a293fe72f1c908e6f",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// MK7S49W8
		"id": 13,
		"organisation": "aag",
		"name": "AAG ",
		"code": "bdb1491811c0466217df30e4424bb146",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// N34F2SGR
		"id": 14,
		"organisation": "vig",
		"name": "Vereniging Innovatieve Geneesmiddelen ",
		"code": "6973f4acc7498b4ec77f3f257860895c",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// PK63C7XS
		"id": 15,
		"organisation": "lhv",
		"name": "LHV",
		"code": "112c55bad9eb643dab14e91ed6f4d09c",
		"specials": ['huisartsenzorg']
	},
	{
		// QKC86G2H
		"id": 16,
		"organisation": "sboh",
		"name": "Stichting SBOH",
		"code": "d2a7149b2629b53088c71c82946be5c8",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// REQ8CT3P
		"id": 17,
		"organisation": "profclass",
		"name": "PROFclass",
		"code": "2d560221c633013fe99b1b99bc6c9b31",
		"specials": ['huisartsenzorg']
	},
	{
		// SQ9F3MRW
		"id": 18,
		"organisation": "particulier-ouderenzorg",
		"name": "particulier ouderenzorg",
		"code": "2cb57695fafdf1c3d2b8fe4ec8ebcb96",
		"specials": ['ouderenzorg']
	},
	{
		// T9WQ3MP8
		"id": 19,
		"organisation": "azn",
		"name": "Ambulancezorg Nederland",
		"code": "cf4ad3b551f95befd4cea2695381e53b",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// U3KL72HA
		"id": 20,
		"organisation": "nza",
		"name": "Nederlandse Zorgautoriteit",
		"code": "52737732059122ecd59f3f47384a31b8",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// W78DP2A2
		"id": 21,
		"organisation": "actiz",
		"name": "Actiz",
		"code": "f80e8870ddb1a80855e48948b3dd941a",
		"specials": ['ouderenzorg']
	},
	{
		// X9G34K4A
		"id": 22,
		"organisation": "anbo",
		"name": "ANBO",
		"code": "4d908f04c9253e9fe8cf02a22a996113",
		"specials": ['ouderenzorg']
	},
	{
		// Y9GK638G
		"id": 23,
		"organisation": "prismant",
		"name": "Prismant",
		"code": "73710806f67e853a2fd6bb20ef1f956e",
		"specials": ['ouderenzorg']
	},
	{
		// ZZ83HS5Q
		"id": 24,
		"organisation": "soon",
		"name": "SOON",
		"code": "ab0a0a57f6165f6172ef6b3917650523",
		"specials": ['ouderenzorg']
	},
	{
		// AG9H3B2Q
		"id": 25,
		"organisation": "verenso",
		"name": "Verenso",
		"code": "3232a1ccc98c22fdfd2d2fd5f77db522",
		"specials": ['ouderenzorg']
	},
	{
		// 6QFK49RH
		"id": 26,
		"organisation": "ggdghor",
		"name": "GGD GHOR Nederland",
		"code": "7d3a2a6aa7f94b4ce8edb107514a33be",
		"specials": ['publieke-gezondheidszorg']
	},
	{
		// 57U5BBRV
		"id": 27,
		"organisation": "kamg",
		"name": "Verenso",
		"code": "72a092e06ad1a24d79e078c0bb3ed0fa",
		"specials": ['publieke-gezondheidszorg']
	},
	{
		// EUEK7Y7G
		"id": 28,
		"organisation": "particulier-pgz",
		"name": "particulier publieke gezondheidszorg",
		"code": "77781829e6de62e076d2a4b189257a96",
		"specials": ['publieke-gezondheidszorg']
	},
	{
		// 59N4PSHP
		"id": 29,
		"organisation": "vng",
		"name": "vereniging van nederlandse gemeenten",
		"code": "75227bd1fedccd246240f06ba5bda44c",
		"specials": ['huisartsenzorg','ouderenzorg', 'publieke-gezondheidszorg', 'geneesmiddelenzorg']
	},
	{
		// 9ASHJQUU
		"id": 30,
		"organisation": "cbg",
		"name": "college ter beoordeling van geneesmiddelen",
		"code": "06039a63556eaec832c5db9802c1efa2",
		"specials": ['geneesmiddelenzorg']
	},
	{
		// MJN7KT4D
		"id": 31,
		"organisation": "hollandbio",
		"name": "holland bio",
		"code": "84801b3df0d9363007bae831da435fb0",
		"specials": ['geneesmiddelenzorg']
	},
	{
		// 52CDFNYU
		"id": 32,
		"organisation": "knmp",
		"name": "koninklijke nederlandse maatschappij ter bevordering van pharmacie",
		"code": "e50b8c2e8640ec405556cc88a2b45a0f",
		"specials": ['geneesmiddelenzorg']
	},
	{
		// REH53KN7
		"id": 32,
		"organisation": "svb",
		"name": "sociale verzekeringsbank",
		"code": "ea0d83b2db1e2b75da6dfd43c7def491",
		"specials": ['geneesmiddelenzorg']
	},
]
